'use strict';

var toast = require('core/components/toast');
var formValidation = require('base/components/formValidation');
var recaptcha = require('core/components/recaptcha');

module.exports = {
    loyaltyCalloutButton: function() {
        var closeCallout = function() {
            $('.loyalty-callout-button').fadeOut();
            var url = $('.loyalty-callout-button').data('closeUrl');
            if (url) {
                $.ajax({
                    type: 'POST',
                    url: url,
                    error: function(error) {
                        window.console.error('Loyalty Callout Close Failed', error);
                    }
                });
            }
        };

        $('.loyalty-callout-content').click(function() {
            $('#loyaltyOptInModal').modal('show');
        });

        $('.loyalty-callout-close').click(function(e) {
            e.stopPropagation();
            closeCallout();
        });

        $('#loyaltyOptInModal').on('hidden.bs.modal', function() {
            var wasSuccessful = $('#loyaltyOptInModal .loyalty-success').is(':visible');
            if (wasSuccessful) {
                closeCallout();
            }
        });

        // Hide callout immediately when user opts in successfully
        $('body').on('loyalty:optIn:success', function() {
            closeCallout();
        });
    },

    loyaltyFormHandler: function() {
        var ns = '.loyaltyForm ';

        // Handle loyalty opt-in form checkbox change
        $('#loyaltyOptInModal')
        .off(ns)
        .on('change' + ns, '#loyaltyOptInCheckbox', function() {
            var isChecked = $(this).is(':checked');
            $('.loyalty-submit-btn').prop('disabled', !isChecked);
        });

        // Handle form submission
        $('#loyaltyOptInForm')
        .off(ns)
        .on('submit' + ns, function(e) {
            e.preventDefault();

            var $form = $(this);
            var $submitBtn = $form.find('.loyalty-submit-btn');

            if (!$form.find('#loyaltyOptInCheckbox').is(':checked')) {
                return false;
            }

            $submitBtn.prop('disabled', true);
            $.spinner().start();

            $.ajax({
                type: 'POST',
                url: $form.attr('action'),
                data: $form.serialize(),
                success: function(response) {
                    if (response.success) {
                        // Show success state across all loyalty forms
                        $('#loyaltyOptInForm').closest('.modal-body').addClass('d-none');
                        $('#loyaltyOptInModal .loyalty-success').removeClass('d-none');

                        // Force Modal open if not already
                        $('#loyaltyOptInModal').modal('show');

                        // Trigger custom event for analytics/tracking
                        $('body').trigger('loyalty:optIn:success', response);
                    } else {
                        // Show error message
                        displayLoyaltyError(response.message);
                        $submitBtn.prop('disabled', false);
                    }
                },
                error: function(xhr) {
                    var msg = xhr.responseJSON && xhr.responseJSON.message;
                    var fallbackMsg = $('#loyaltyOptInModal').data('error-msg') || 'An error occurred. Please try again.';
                    displayLoyaltyError(msg || fallbackMsg);
                    $submitBtn.prop('disabled', false);
                },
                complete: () => $.spinner().stop()
            });

            return false;
        });

        // reset modal state when closed
        $('#loyaltyOptInModal').on('hidden.bs.modal', function() {
            // Check if user successfully subscribed before resetting modal state
            var wasSuccessful = !$('#loyaltyOptInModal .loyalty-success').hasClass('d-none');

            // Reset modal state
            $('#loyaltyOptInForm').closest('.modal-body').removeClass('d-none');
            $('#loyaltyOptInModal .loyalty-success').addClass('d-none');
            $('#loyaltyOptInCheckbox').prop('checked', false);
            $('.loyalty-submit-btn').prop('disabled', true);
            $('.loyalty-error-message').remove();

            // Refresh page if user successfully subscribed to show updated pricing
            if (wasSuccessful) {
                window.location.reload();
            }
        });
    },

    loyaltyOptInToggle: function () {
        $('.js-loyalty-optin-checkbox').on('change', function () {
            var $checkbox = $(this);
            var $form = $checkbox.closest('.loyalty-optin-form');
            var $card = $checkbox.closest('.loyalty-optin-card');
            var isChecked = $checkbox.is(':checked');
            var url = isChecked ? $card.data('optin-url') : $card.data('optout-url');
            var successMessage = $card.data('success-message');
            var errorMessage = $card.data('error-message');

            $form.data('$xhr', $.ajax({
                url: url,
                type: 'POST',
                beforeSend: () => {
                    $form.data('$xhr')?.abort?.();
                    $checkbox.prop('disabled', true);
                    $card.spinner().start();
                },
                success: function (response) {
                    if (!response.success) {
                        $.spinner().stop();
                        // revert checkbox on failure
                        $checkbox.prop('checked', !isChecked);
                        toast.methods.show('danger', response.message || errorMessage, false);
                    } else {
                        toast.methods.show('success', response.message || successMessage, false);
                        $('body').trigger('loyalty:optIn:success');
                    }
                },
                error: function () {
                    // revert checkbox on error
                    $checkbox.prop('checked', !isChecked);
                    toast.methods.show('danger', errorMessage, false);
                },
                complete: function () {
                    $checkbox.prop('disabled', false);
                    $card.spinner().stop();
                }
            }));
        });
    },

    /**
     * Loyalty PDP card click handler
     * - For unauth users: opens sign-up/login modal
     * - For auth users: opens loyalty opt-in modal
     */
    loyaltyPdpCardHandler: function () {
        var $pdpCard = $('.loyalty-optin-card-pdp');
        if ($pdpCard.length === 0) return;
        var targetModal = $pdpCard.data('target');

        $pdpCard.on('keydown', function (e) {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                $(targetModal).modal('show');
            }
        });

        var $loyaltySignUpModal = $('#loyaltySignUpModal');

        $loyaltySignUpModal.on('hidden.bs.modal', function () {
            $('#loyalty-register-tab').tab('show');
            // Find recaptcha badge and hide it
            $('.grecaptcha-badge').css('visibility', 'hidden');
        });

        $('body').on('loyalty:optIn:success', function () {
            $pdpCard.fadeOut();
        });
    },

    /**
     * Handle loyalty opt-in checkbox in registration form
     * The loyalty checkbox is disabled by default, except it should be enabled on load if
     * the "add to email list" checkbox is checked.
     */
    registrationLoyaltyCheckbox: function () {
        var $emailCheckbox = $('#add-to-email-list');
        var $loyaltyCheckbox = $('#loyalty-optin-checkbox');

        if ($emailCheckbox.length === 0 || $loyaltyCheckbox.length === 0) {
            return;
        }

        // Handler to sync loyalty checkbox state with email checkbox
        var syncLoyaltyCheckbox = function () {
            var isEmailChecked = $emailCheckbox.is(':checked');

            // Enable or disable the loyalty checkbox based on email checkbox
            $loyaltyCheckbox.prop('disabled', !isEmailChecked);

            // If email list is unchecked, also uncheck loyalty
            if (!isEmailChecked) {
                $loyaltyCheckbox.prop('checked', false);
            }
        };

        // On initial page load, explicitly check and set the state
        if ($emailCheckbox.is(':checked')) {
            $loyaltyCheckbox.prop('disabled', false);
        } else {
            $loyaltyCheckbox.prop('disabled', true);
            $loyaltyCheckbox.prop('checked', false);
        }

        // Also run the sync to cover edge cases or multiple calls
        syncLoyaltyCheckbox();

        // Listen for changes to the email checkbox
        $emailCheckbox.on('change', syncLoyaltyCheckbox);
    },

    /**
     * Override login/registration form handlers inside the loyalty signup modal
     * to refresh the current page instead of redirecting away
     */
    loyaltyModalFormHandler: function () {
        var $modal = $('#loyaltySignUpModal');

        if ($modal.length === 0) return;

        // Prevent the default browser submission
        $modal.find('form.login')[0]?.addEventListener('submit', event => event?.preventDefault() && false);

        // Handle login form submission inside the modal
        $modal
            .off('submit', 'form.login')
            .on('submit', 'form.login', function (e) {
                e.preventDefault();
                e.stopPropagation();

                var $form = $(this);
                var url = $form.attr('action');

                $form.spinner().start();
                $('form.login').trigger('login:submit', e);

                recaptcha.check(e, {
                    url: url,
                    type: 'post',
                    dataType: 'json',
                    data: $form.serialize(),
                    success: function (data) {
                        if (!data.success) {
                            formValidation($form, data);
                            $form.spinner().stop();
                            $('form.login').trigger('login:error', data);
                        } else {
                            $('form.login').trigger('login:success', data);
                            // Close modal and refresh current page
                            $modal.modal('hide');
                            window.location.reload();
                        }
                    },
                    error: function (data) {
                        if (data.responseJSON && data.responseJSON.redirectUrl) {
                            window.location.href = data.responseJSON.redirectUrl;
                        } else {
                            $('form.login').trigger('login:error', data);
                            $form.spinner().stop();
                        }
                    }
                });

                return false;
            });

        // Handle registration form submission inside the modal
        $modal
            .off('submit', 'form.registration')
            .on('submit', 'form.registration', function (e) {
                e.preventDefault();
                e.stopPropagation();

                var $form = $(this);
                var url = $form.attr('action');

                $form.spinner().start();
                $('form.registration').trigger('login:register', e);

                recaptcha.check(e, {
                    url: url,
                    type: 'post',
                    dataType: 'json',
                    data: $form.serialize(),
                    success: function (data) {
                        if (!data.success) {
                            $('form.registration').trigger('login:register:error', data);
                            formValidation($form, data);
                            $form.spinner().stop();
                        } else {
                            $('form.registration').trigger('login:register:success', data);
                            // Close modal and refresh current page
                            $modal.modal('hide');
                            window.location.reload();
                        }
                    },
                    error: function (err) {
                        if (err.responseJSON && err.responseJSON.redirectUrl) {
                            window.location.href = err.responseJSON.redirectUrl;
                        } else if (err.responseJSON && err.responseJSON.errorMessage) {
                            var createErrorNotification = require('base/components/errorNotification');
                            createErrorNotification($form.find('.error-messaging'), err.responseJSON.errorMessage);
                        }
                        $form.spinner().stop();
                    }
                });

                return false;
            });
    },
    showLoyaltyModal: function () {
        var $loyaltyOptInModal = $('#loyaltyOptInModal');
        var markShownUrl = $('.loyaltyModalSettings').data('mark-shown-url');

        if (markShownUrl) {
            // mark shown in session
            $loyaltyOptInModal.on('shown.bs.modal', function () {
                $.ajax({
                    type: 'POST',
                    url: markShownUrl,
                    error: function(error) {
                        window.console.error('Failed to mark loyalty modal as shown', error);
                    }
                });
            });
        }
    },
    loyaltyModalPop: function () {
        var $loyaltyOptInModal = $('#loyaltyOptInModal');
        var $loyaltySettings = $('.loyaltyModalSettings');
        if ($loyaltySettings.length === 0) {
            return;
        }

        var actionUrl = $loyaltySettings.data('action-url');

        // Check if we should show modal (after login redirect)
        var urlParams = new URLSearchParams(window.location.search);
        var showLoyaltyOnLoad = urlParams.get('showLoyalty') === 'true';

        var $loyaltyCalloutButton = $('.loyalty-callout-button');
        var $loyaltyCheckbox = $('.loyalty-opt-in');
        var $loyaltySubmitBtn = $('.loyalty-submit-btn');

        // fetch modal settings from server
        $.ajax({
            type: 'GET',
            url: actionUrl,
            success: function(response) {
                if (response.success && response.loyaltyModal) {
                    var settings = response.loyaltyModal;

                    if (settings.showCalloutButton) {
                        var visibility = settings.calloutVisibility || 'show';
                        var isPDP = $('.page[data-action*="Product-Show"]').length > 0;
                        var shouldShowCallout = visibility === 'show' || (visibility === 'showExceptPDP' && !isPDP);

                        if (shouldShowCallout) {
                            $loyaltyCalloutButton.data('closeUrl', settings.closeCalloutUrl);
                            $loyaltyCalloutButton.fadeIn();
                        }
                    }
                    // set the opt-in form action URL
                    $loyaltyCheckbox.closest('form').attr('action', settings.optInUrl);

                    var shouldShowNow = settings.showModalOnLogin ||
                                        showLoyaltyOnLoad ||
                                        sessionStorage.getItem('showLoyaltyModal') === 'true';

                    if (settings.enabled && shouldShowNow) {
                        // Precheck the loyalty opt-in checkbox if needed
                        if (settings.triggerSubmit) {
                            $('.loyalty-modal-content').find('.new-account, .existing-account').toggleClass('d-none');
                            $loyaltyCheckbox.prop('checked', true);
                            $loyaltySubmitBtn.prop('disabled', false);
                            $loyaltySubmitBtn.closest('form').trigger('submit');
                        }

                        // clean up URL param if present
                        if (showLoyaltyOnLoad) {
                            var cleanUrl = window.location.pathname + window.location.search.replace(/[?&]showLoyalty=true/, '').replace(/^&/, '?');
                            window.history.replaceState({}, document.title, cleanUrl || window.location.pathname);
                        }

                        // clear session flag
                        sessionStorage.removeItem('showLoyaltyModal');

                        var modalDelay = settings.delay || 0;

                        setTimeout(function() {
                            $loyaltyOptInModal.modal('show');
                        }, modalDelay);
                    }

                    // also listen for login success event (AJAX)
                    $('form.login').on('login:success', function() {
                        // store flag in session
                        sessionStorage.setItem('showLoyaltyModal', 'true');
                    });
                }
            },
            error: function(error) {
                window.console.error('Loyalty Modal Settings Failed', error);
            }
        });
    }
};

function displayLoyaltyError(message) {
    $('.loyalty-error-message').remove();

    var $error = $('<div class="alert alert-danger loyalty-error-message">' + message + '</div>');
    $('#loyaltyOptInForm').prepend($error);
}

